<template>
  <div class="">
    <div
      style="    display: flex;
    justify-content: center;"
    >
      <div
        class="col-xxl-10 col-lg-12 col-md-12"
        style="background-color: #f7fbff"
      >
        <PageHeader :title="poll.title" subtitle="Diligenciar" />
        <b-card
          v-if="Object.keys(pollData).length > 0"
          class="card-form shadow p-1 py-2 mt-lg-2 mt-xs-4"
          style="margin-top: 0.75rem"
          no-body
        >
          <b-overlay
            :show="isSaving"
            blur="5px"
            :opacity="1"
            variant="transparent"
            spinner-variant="primary"
            spinner-type="grow"
            rounded="sm"
          >
            <ValidationObserver id="typeForm" ref="observer">
              <b-tabs
                v-model="tabIndex"
                ref="tabs"
                small
                card
                @activate-tab="tabActivated"
                class="tabs-forms"
              >
                <!-- <ValidationObserver ref="obs0" v-slot="{ handleSubmit }"> -->
                <!-- <b-tab id="obs0" title="Variables" class="base-vars p-2">
                    <b-card
                      v-for="(dimension, key) in pollData.dimensions"
                      :key="`dim-${dimension.id}-${key}-base`"
                      no-body
                      class="section-card"
                      v-show="Object.keys(dimension.variables).length > 0"
                    >
                      <b-card-header class="pl-2 bg-transparent">
                        <h6 class="text-primary"
                          >{{ dimension.name }}
                          <small class="text-muted d-none">{{
                            dimension.description
                          }}</small></h6
                        >
                      </b-card-header>
                      <b-card-body class="p-0 pb-1">
                        <div class="row">
                          <div
                            class="col-md-6"
                            v-for="(variable, index) in dimension.variables"
                            :key="
                              `dim-${dimension.id}-base-${index}-${
                                variable.idk
                              }`
                            "
                          >
                            <renderVariable
                              :variable="variables"
                              :isComponent="false"
                              :isPreview="false"
                              :validateDependents="validateDependents"
                              :isPollFill="true"
                              :findDataAutocomplete="findDataAutocomplete"
                              :autoCompleteInputDisable="
                                autoCompleteInputDisable
                              "
                            />
                          </div>
                        </div>
                      </b-card-body>
                    </b-card>
                    <div class="row">
                      <div class="col-md-12">
                        <b-button
                          v-if="tabIndex !== 1 && !autoCompleteInputDisable"
                          class="float-right"
                          variant="primary"
                          pill
                          @click="handleSubmit(savePoll)"
                          >Siguiente</b-button
                        >
                      </div>
                    </div>
                  </b-tab> -->
                <!-- </ValidationObserver> -->
                <ValidationObserver ref="obs0" v-slot="{ handleSubmit }">
                  <b-tab id="obs0" title="Variables" class="extended-vars p-2">
                    <b-card
                      v-for="(dimension, key) in pollData.dimensions"
                      :key="`dim-${dimension.id}-${key}-extended`"
                      no-body
                      class="section-card"
                      v-show="
                        Object.keys(
                          dimension.variables.filter(
                            (y) => y.display === true
                          ) || {}
                        ).length > 0
                      "
                    >
                      <b-card-header class="pl-2 bg-transparent">
                        <h6 class="text-primary"
                          >{{ dimension.name }}
                          <small class="text-muted d-none">{{
                            dimension.description
                          }}</small></h6
                        >
                      </b-card-header>
                      <b-card-body class="p-0 pb-1">
                        <div class="row">
                          <div
                            v-for="(variable, index2) in dimension.variables"
                            :key="
                              `prev-dim-${dimension.id}-var-${index2}-${
                                variable.idk
                              }-${variable.display}-${renderTimestamp}`
                            "
                            class="col-md-6"
                          >
                            <div v-if="variable.display">
                              <renderVariable
                                :key="`${renderTimestamp}`"
                                :data-display="
                                  `${variable.variable}-${
                                    variable.display
                                  }-${renderTimestamp}`
                                "
                                :variable="variable"
                                :isComponent="false"
                                :isPreview="false"
                                :validateDependents="validateDependents"
                              />
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </b-card>
                    <div class="row">
                      <div class="col-md-12">
                        <!-- {{ formData['dimensions'][1] }} -->
                        <!-- <b-button
                          v-if="tabIndex > 0"
                          variant="primary"
                          pill
                          @click="tabIndex--"
                          >Ir atrás</b-button
                        > -->
                        <b-button
                          class="float-right"
                          variant="primary"
                          pill
                          @click="handleSubmit(savePoll)"
                          v-b-tooltip.hover="{
                            variant: 'info',
                            title: 'Guardar Encuesta',
                          }"
                          >Guardar</b-button
                        >
                      </div>
                    </div>
                  </b-tab>
                </ValidationObserver>
              </b-tabs>
            </ValidationObserver>
          </b-overlay>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Layout from '@layouts/main'
import { Drag, Drop, DropList } from 'vue-easy-dnd'
import PageHeader from '@components/page-header'
import { encrypt, decrypt } from '@utils/local-storage'
import handleObject from '@/src/utils/handle-objects'
import _ from 'lodash'
// let _moment = require('moment')

import {
  formMethods,
  variablesMethods,
  usersMethods,
  pollMethods,
} from '@state/helpers'

import InputText from '@components/form/InputText'
import InputTextarea from '@components/form/InputTextarea'
import InputSelect from '@components/form/InputSelect'
import InputMultiSelect from '@components/form/InputMultiSelect'
import InputRadio from '@components/form/InputRadio'
import InputCheckbox from '@components/form/InputCheckbox'

import RenderVariable from '@views/variables/renderVariable.vue'

export default {
  page: {
    title: 'Diligenciar Encuesta',
  },
  components: {
    Layout,
    PageHeader,
    Drag,
    Drop,
    DropList,
    InputText,
    InputTextarea,
    InputRadio,
    InputSelect,
    InputMultiSelect,
    InputCheckbox,
    RenderVariable,
  },
  data() {
    let stateObj = [{ id: 'A', name: 'Activo' }, { id: 'I', name: 'Inactivo' }]

    return {
      autoCompleteInputDisable: true,
      isSaving: false,
      initPollSW: true,
      renderTimestamp: Date.now(),
      tabIndex: 0,
      lastTabError: null,
      title: 'Poll',
      locale: 'es',
      pollData: {},
      editMode: false,
      actionToClean: false,
      dataPollsFill: {},
      variablesTodo: [],
      allVariables: {},

      extendedVariableSearch: '',
      dimensions: {},
      poll: {
        id: null,
        title: '',
        state: stateObj.filter((x) => x.id === 'A')[0],
      },
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Encuestas',
          active: true,
        },
      ],
      lists: [],
      extraButtons: [
        {
          variant: 'success',
          title: 'Diligenciar Encuestas',
          to: { name: 'pollFillList' },
          icon: 'arrow90deg-left',
        },
      ],
    }
  },

  mounted() {
    this.initPoll()
  },

  methods: {
    ...formMethods,
    ...variablesMethods,
    ...pollMethods,
    getSavedState(key) {
      key =
        JSON.parse(this.getStateLocalStorage('auth.currentSession')).user
          .username +
        '.' +
        key
      let retorno = JSON.parse(this.getStateLocalStorage(key))
      return retorno
    },
    getStateLocalStorage(key) {
      let storage = window.localStorage.getItem(key)
      if (storage != null) {
        if (typeof storage == Object && storage.length < 0) {
          return '[]'
        }
        return decrypt(storage)
      } else {
        return '[]'
      }
    },

    initPoll() {
      this.initPollSW = true
      this.pollData = {}
      this.poll = {}
      this.tabIndex = 0
      this.dimensions = {}
      this.variablesTodo = []
      this.dataPollsFill = {}
      this.getPollswithToken({
        token: this.$route.params.token,
      }).then((result) => {
        this.dataPollsFill = result
        const resultadosDimensiones = this.dataPollsFill.dimensions.map(
          (item) => {
            return {
              id: item.id,
              name: item.name,
              description: item.description,
              variables: item.variables,
            }
          }
        )

        this.allVariables =
          this.dataPollsFill &&
          this.dataPollsFill.dimensions
            .map((x) => {
              return {
                id: x.id,
                name: x.name,
                order: x.order,
                dimension_id: x.dimension_id,
                poll: x.poll,
                items: x.variables,
              }
            })
            .filter((y) => y.items.length > 0)
            .sort((a, b) => (a.order > b.order && 1) || -1)
        this.variablesTodo = this.allVariables
        let poll_id = this.dataPollsFill.id

        this.poll = { ...this.dataPollsFill }
        this.pollData = {
          poll: poll_id,
          mode: 'record',
          dimensions: resultadosDimensiones,
        }
        // hide extended depends variables:
        this.variablesTodo.forEach((x) => {
          x.items.forEach((y) => {
            if (!!y.extra_config.depends) {
              y.display = false
            } else {
              y.display = true
            }
          })
        })
      })
    },

    savePoll(action = null) {
      this.isSaving = true
      let _ = this
      const dataSend = this.pollData
      const promise = this.setPollWithToken({
        data: dataSend,
        token: this.$route.params.token,
      })
      return promise
        .then((data) => {
          _.isSaving = false
          if (data.hasOwnProperty('id')) {
            _.pollData.id = data.id
            _.editMode = true
          }
          if (data.hasOwnProperty('key')) {
            _.pollData.key = data.key
          }
          if (data.hasOwnProperty('start_time')) {
            _.pollData.start_time = data.start_time
          }
          const msg_queue =
            data.queue_sessions > 0
              ? `${data.queue_sessions} registros pendientes por sincronizar`
              : ''
          _.$generate_noty(
            'success',
            `Encuesta ${_.editMode ? 'actualizado' : 'guardado'} ${
              _.pollData.id !== null ? 'remotamente' : 'localmente'
            }.<br><b>${msg_queue}</b>`
          )
          if (_.tabIndex === 0) {
            _.$nextTick(() => {
              _.isSaving = false
              _.initPoll()
              _.$generate_noty(
                'info',
                `La encuesta se ha guardado exitosamente`
              )
            })
          }
        })
        .catch((error) => {
          _.isSaving = false
          _.$generate_noty(
            'error',
            'Se presento un error al guardar la encuesta'
          )
          console.log('error', error)
        })
    },

    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },

    async tabActivated(newTabIndex, prevTabIndex, bvEvent) {
      if (this.initPollSW === true) {
        this.$refs['observer'].observers[0].reset()
        this.initPollSW = false
        return true
      }
      if (this.$refs['observer'].observers[prevTabIndex] !== undefined) {
        const valid = await this.$refs['observer'].observers[
          prevTabIndex
        ].validate()
        if (!valid && this.lastTabError === null) {
          this.lastTabError = prevTabIndex
          bvEvent.preventDefault()
          this.$generate_noty(
            'error',
            `Hay errores en la encuesta ${
              this.$refs['tabs'].registeredTabs[prevTabIndex].title
            }, verifique`
          )
          await this.sleep(400)
          this.tabIndex = prevTabIndex
        } else {
          this.lastTabError = null
          this.tabIndex = newTabIndex
        }
      }
    },

    getVariableInfoById(id) {
      let variable = []
      this.poll.dimensions.forEach((element) => {
        element.variables.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
      })
      this.variablesTodo.forEach((element) => {
        element.items.forEach((element2) => {
          if (element2.variable === parseInt(id)) {
            variable = element2
          }
        })
      })
      return variable
    },

    getVariableDependents(id) {
      let dependents = []
      this.variablesTodo.forEach((element) => {
        element.items.forEach((element2) => {
          if (element2.extra_config.depends === parseInt(id)) {
            dependents.push(element2.variable)
          }
        })
      })
      return dependents
    },

    validateDependents(variable) {
      const dependents =
        variable.extra_config.dependents ||
        this.getVariableDependents(variable.variable)
      this.$nextTick(() => {
        dependents.forEach((x) => {
          let var_ = this.getVariableInfoById(x)
          if (Object.keys(variable.value).length > 0) {
            const cond = var_.extra_config.depends_condition
            const dep_val = var_.extra_config.depends_value
            if (
              cond === 'IN' &&
              (variable.value === dep_val || variable.value.key
                ? Object.values(dep_val).filter(
                    (x) => x.trim() === variable.value.key.trim()
                  ).length > 0
                : dep_val in
                  variable.value.map((x) => {
                    return x.key
                  }))
            ) {
              var_.display = true
            } else if (
              cond === 'NOT_IN' &&
              (variable.value !== dep_val && variable.value.key
                ? Object.values(dep_val).filter(
                    (x) => x.trim() === variable.value.key.trim()
                  ).length === 0
                : !dep_val in
                  variable.value.map((x) => {
                    return x.key
                  }))
            ) {
              var_.display = true
              if ('required' in var_.extra_config) {
                var_.extra_config.required = true
              }
            } else {
              var_.display = false
              if ('required' in var_.extra_config) {
                var_.extra_config.required = false
              }
            }
          } else {
            var_.display = false
            if ('required' in var_.extra_config) {
              var_.extra_config.required = false
            }
          }
          this.renderTimestamp = Date.now()
          // this.setVariableInfoById(x, var_)
        })
      })
    },
  },
  // watch: {
  //   'pollData.dimensions': {
  //     deep: true,
  //     handler(newValue, oldValue) {
  //       console.log('pollData', this.pollData, newValue)
  //     },
  //   },
  // },
}
</script>

<style lang="scss">
#extra-config-modal .custom-select-md {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 0.95rem;
}
.with-separator {
  border-top: 1px solid #dee2e6 !important;
}
.dnd-drag.drag-out.drag-no-handle {
  .list-group-item {
    background-color: #f5fafd;
    color: gray;
    border: #e5eaee 1px solid;
  }
}

.tabs-forms .nav-link.disabled {
  color: gray !important;
}

.extended-vars,
.base-vars {
  .left-panel {
    margin-top: 1px;
  }
  .dimension-title {
    border-top: 1px solid rgb(238, 238, 238);
  }
  .btn.btn-block {
    .opened,
    .closed {
      float: right !important;
      margin-top: 4px;
      color: #226aa7;
      transition: transform 0.15s ease-in-out,
        background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }

    &.collapsed {
      .opened {
        display: none;
      }
      .closed {
        display: inline;
      }
    }
    &.not-collapsed {
      .opened {
        display: inline;
      }
      .closed {
        display: none;
      }
    }
  }
  .search {
    .form-control {
      height: 38px;
      padding-right: 0;
      padding-left: 20px;
      color: #000;
      background-color: rgba(255, 255, 255, 0.07);
      border: 1px solid rgba(0, 0, 0, 0.03);
      border-radius: 30px 0 0 30px;
      border-right: none;
      box-shadow: none;
    }
    .btn {
      color: #2185d0;
      background-color: rgba(255, 255, 255, 0.07);
      border-color: rgba(0, 0, 0, 0.03);
      border-radius: 0 30px 30px 0;
      box-shadow: none !important;
      border-left: none;
    }
  }
  .section-card {
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 10px;
  }
  .list2 {
    min-height: 140px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .card {
      border: 1px dashed #48c0f5;
      border-bottom: 3px solid #48c0f5;
      border-radius: 5px;

      .handle-cursor:hover {
        background-color: #48c1f51f;
      }

      &.dependent {
        border: 1px dashed #f7b84b;
        border-bottom: 3px solid #f7b84b;
        svg {
          color: #c79e51 !important;
        }
        .handle-cursor:hover {
          background-color: #ffbb4625;
        }
      }
      .handle-cursor {
        cursor: move;
      }
    }

    &.empty {
      text-align: center;
      // background-color: #f5fafd;
      padding: 10px;
    }
    &.empty::after {
      content: 'Arrastre y suelte la variable aquí';
      background-image: url('~~~@assets/images/add-form-img.png');
      background-position: center center;
      background-repeat: no-repeat;
      color: rgb(204, 204, 204);
      font-size: 14px;
      width: 100%;
      text-align: center;
      margin-top: 18px;
    }
    &.drop-allowed.empty::after {
      content: 'Suelte aquí para insertar la variable';
      background-image: none;
      font-size: 16px;
    }
    &.drop-forbidden {
      background-color: rgba(255, 0, 0, 0.12);
    }
    &.drop-allowed {
      background-color: rgba(61, 65, 255, 0.12);
    }
  }
  .section-name {
    .form-control {
      background-color: transparent !important;
      border: transparent !important;
      font-size: 18px;
    }
    .input-group-text {
      background-color: transparent !important;
      border: none;
    }
  }
}
</style>
